<template>
  <div class="wrapper contact-page">
    <div class="page-header page-header-small">
      <parallax
          class="page-header-image"
          :style="{ backgroundImage: `url(${bgImage})` }"
      />
    </div>
    <div class="main">
      <div class="contact-content">
        <div class="container">
          <div class="row">
            <div class="col-md-12 ml-auto mr-auto">
              <h2 class="title">
                Datenschutz&shy;bereich
              </h2>
            </div>
            <div class="col-md-5 ml-auto mr-auto">
              <info-section
                  type="primary"
                  class="mt-5"
                  icon="now-ui-icons location_pin"
              >
                <h4 class="info-title">
                  Wo werden meine Daten gespeichert?
                </h4>
                <p>
                  Ihre Daten werden bei der Interxion in Dänemark gespeichert.
                  Dort ist ein Rechenzentrum, das die Infrastruktur für den Service bereitstellt,
                  automatisierte Backups macht und diese selbstverständlich auch wieder einspielen kann.
                </p>
              </info-section>
            </div>
            <div class="col-md-5 ml-auto mr-auto">
              <info-section
                  type="primary"
                  class="mt-5"
                  icon="business_briefcase-24 now-ui-icons"
              >
                <h4 class="info-title">
                  Arbeiten Sie selbst DSGVO konform?
                </h4>
                <p>
                  Ja, selbstverständlich!
                  Unsere Daten verlassen weder den europäischen Raum, noch werden Sie an Dritte weitergegeben.
                  Weiters sind die Daten in der Datenbank verschlüsselt, sodass weder wir noch Sie sich Sorgen darum
                  machen müssen!
                </p>
              </info-section>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-12 ml-auto mr-auto">
              <info-section
                  type="primary"
                  class="mt-5"
                  icon="business_badge now-ui-icons"
              >
                <h4 class="info-title"> Welche Daten werden verarbeitet?</h4>
                <p>
                  Zur Erstellung Ihres Kundenkontos benötigen wir Ihre Firmendaten
                  (zur Vertragserstellung des Auftragsverarbeitungsvertrags) als auch Ihre Mailadresse
                  sowie die Telefonnummer einer Ansprechperson (jeweils zur Kontaktaufnahme).
                  Für die Nutzung der Plattform durch Ihre Kunden verarbeiten wir jene Daten,
                  die Sie uns zur Verfügung stellen. Das ist zumindest die Mailadresse
                  sofern diese einen Kontakt in Ihrem Kundestamm eindeutig identifiziert.
                  Weiters können Sie uns optional noch den Vornamen, Nachnamen,
                  das Geschlecht und die eindeutige Identifikationsnummer (kurz ID) Ihres Primärsystems bekanntgeben,
                  um Daten via Schnittstelle oder manuell wieder dorthin übertragen zu können.
                </p>
              </info-section>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-12 ml-auto mr-auto">
                <p>
                  Falls Sie hier einen Auftragsverarbeitungsvertrag herunterladen wollen,
                  müssen wir Sie leider enttäuschen. Sie bekommen diesen nach der Erstellung Ihres Kundenkontos.
                  Das hat den Hintergrund, dass wir nur nach dem Login technisch sichergehen können,
                  dass Sie sich Ihren Auftragsverarbeitungsvertrag heruntergeladen und akzeptiert haben.
                  Sollten Sie den Link mit dem Sie der Auftragsverarbeitung digital zustimmen nicht
                  innerhalb von einer Woche anklicken, müssen wir aus rechtlicher Sicht Ihre Daten leider löschen.
                  Bitte beachten Sie, dass wir auch keine Linkgenerierung vornehmen solange Sie noch keine Einwilligung zur
                  Verarbeitung gegeben haben!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Button, InfoSection, FormGroupInput} from '@/components';
import {API_KEY} from '@/constants'
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY
  }
});
export default {
  name: 'ContactUs',
  bodyClass: 'contact-page',
  components: {
    InfoSection,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        phone: ''
      },
      center: {
        lat: 48.13288227419695,
        lng: 16.26648075587878
      },
      bgImage: require('@/assets/img/bg4.jpg')
    }
  }
}
</script>
